import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { Floor } from '~/models/modules/floor';
import { ApiServiceBase, API_NAMES } from '~/services/api';



@Injectable({ providedIn: 'root' })
export class FloorService extends ApiServiceBase {
  floorClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  FloorAdded: EventEmitter<any> = new EventEmitter();
  FloorUpdated: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  deactivatefloor(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  getListOffloor() {
    return this.http.get<Floor[]>(this._url());
  }

  getfloorByID(id: any) {
    return this.http.get<Floor>(this._url(`/${id}`));
  }

  getxfloorByID(id: any) {
    return this.http.post<Floor>(this._url(`/getby-id`), id);
  }

  createfloor(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  reactivateAnddeactivateFloorBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivatefloor(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }
  getfloordatagrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<Floor[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  updateModelfloor(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  updatefloor(model: any) {
    return this.client.put(this._url(), model);
  }

  getBuildingdatagrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<Floor[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  GetModelChart(floorid: number) {
    return this.client.get(this._url(`/Floor/${floorid}/Chart`));
  }
  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Floor${v}`);
  }

  floorFormClosed(newValue: any) {
    this.floorClosed.next(newValue);
  }

}
